import React from 'react';

type StageProps = {
    width?: string;
    align?: 'left' | 'right' | 'none';
};

export const Stage: React.FC<StageProps> = (props) => {
    return (
        <div
            style={{
                float: props.align ?? 'none',
                fontSize: '14px',
                margin: 'auto',
                backgroundColor: 'lightgray',
                color: 'black',
                width: props.width ?? '400px',
                height: '20px',
                borderRadius: '5px',
                verticalAlign: 'bottom',
                textAlign: 'center',
            }}
        >
            Bühne
        </div>
    );
};
